import styled from '@emotion/styled';
import { Grid } from '@material-ui/core';
import { Magnetic } from '@mitchell/react.component.ux';
export const StyledDivImageFourCorner = styled(Grid, {
    shouldForwardProp: prop => prop !== 'backgroundImage'
})((props) => `
	background: ${Magnetic[props.backgroundImage]} no-repeat center;
	height: 360px;
    width: 100%;
    display: flex;
    margin: 20px 0 100px;
`);
export const FourCornerSecondText = styled.div `
	text-align: center;
	font-size: 12px;
	line-height: 20px;
	margin: 0 10%;
	color: var(--G-900, var(--Text, #121316));
`;
export const StyledFourCornerCameraTopImageContainer = styled.div `
	width: 310px;
	display: flex;
	justify-content: space-between;
	transform: translateY(5px);
`;
export const StyledFourCornerCameraBottomImageContainer = styled.div `
	width: 310px;
	display: flex;
	justify-content: space-between;
	transform: translateY(-150px);
`;
export const StyledFourCornerCameraContainer = styled.div `
	display: flex;
	width: 100%;
	justify-content: center;
	height: 0;
`;
export const StyledCameraTextFourCorner = styled.div `
	color: #929292;
	font-size: ${Magnetic.fontSize12};
	font-style: normal;
	font-weight: ${Magnetic.fontWeightNormal};
	line-height: normal;
	text-align: center;
	margin: auto;
	width: 38px;
	height: 36px;
`;
export const StyledCameraImage = styled.div `
	background-image: url(${props => props.backgroundImage});
	width: 60px;
	height: 60px;
	display: flex;
	justify-content: center;
	align-items: center;
	background-repeat: no-repeat;
	border-radius: 50%;
	background-size: cover;
	background-position: center;
`;
const StyleDivBaseImage = `
	background-repeat: no-repeat;
	background-size: cover;
	background-position: center;
	width: 50px;
	height: 50px;
	outline: ${Magnetic.buttonFlatBorder};
	border-radius: 100%;
	border: ${Magnetic.buttonFlatBorder};
`;
export const StyledIntelligentFourCornerImageButton = styled('button', {
    shouldForwardProp: prop => prop !== 'backgroundImage'
})((props) => `
	${StyleDivBaseImage}	
	background-color: ${props.backgroundColor};
	color: ${Magnetic.colorWhite};
`);
//# sourceMappingURL=IntelligentFourCornersComponent.style.js.map